import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Stack,
  Box,
  FormLabel,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightAddon,
  Select,
  Textarea,
  Button,
} from "@chakra-ui/react";
import {useContext, useState, useEffect, useMemo} from "react";
import AppointmentModal from "./AppointmentModal";
export default function AppointmentModalWraper({dispatch, schState}) {
  return (
    <Drawer
      isOpen={!!schState.selectedAppointment}
      placement="right"
      size={"sm"}
      onClose={() => {
        dispatch({type: "SELECT_APPOINTMENT", payload: null});
      }}
      trapFocus={false}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerBody p={0}>
          <AppointmentModal
            {...{
              dispatch,
              schState,
            }}
          />
        </DrawerBody>

        {/*<DrawerFooter borderTopWidth="1px">
          <Button
            variant="outline"
            mr={3}
            px="10"
            onClick={() => {
              
            }}
          >
            Cancel
            </Button>
          </DrawerFooter>*/}
      </DrawerContent>
    </Drawer>
  );
}
